import React, {useState} from 'react';

import styled from 'styled-components';

import {FineUploaderArea} from 'app/general/widgets/FineUploaderArea';
import {preparedDocsUploader} from 'app/utils/fineuploader';
import {gt} from 'app/utils/i18n';

import type {ObjectToImport} from 'app/docimport/types';

const StyledDropZoneDiv = styled.div`
  .file-upload {
    border: 4px dashed #ccc;
    background: white;
    position: relative;

    .drop {
      visibility: hidden;
      opacity: 0;
      transition: all 250ms;
      background: #f2fdf3;
      z-index: 1;
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      font-size: 1.5rem;
      i {
        font-size: 2.5rem;
      }
    }

    &.active .drop {
      opacity: 1;
      visibility: visible;
    }
  }
`;

type Props = {
  onComplete: (doc: ObjectToImport) => unknown;
  onStart?: () => unknown;
  onCancel?: () => unknown;
};

export const DocumentUploaderArea = ({
  onComplete,
  onCancel,
  onStart,
}: Props) => {
  const [status, setStatus] = useState<
    'idle' | 'uploading' | 'uploaded' | 'processing' | 'success' | 'error'
  >('idle');

  return (
    <StyledDropZoneDiv className={status}>
      <FineUploaderArea
        awsUploadProfile="DOCIMPORT"
        multiple={false}
        uploaderFactory={preparedDocsUploader}
        className="d-flex flex-column align-items-center justify-content-center file-upload py-4"
        uploadListRender={(uploadsFileList) => uploadsFileList}
        onUploadStart={() => {
          setStatus('uploading');
          if (onStart != null) {
            onStart();
          }
        }}
        onUploadCancel={onCancel}
        onUploadComplete={(path, key, id, originalFilename) =>
          onComplete({key, originalFilename})
        }
      >
        {(FileInput, uploader) => (
          <>
            <div className="drop d-flex flex-column align-items-center lead justify-content-center">
              <i className="fa fa-check-circle" />
              <div>{gt('Drop here')}</div>
            </div>
            <div className="qq-upload-drop-area lead mt-1 mb-4 mx-5 text-center">
              {gt(
                'Drag and drop a Word document in .DOCX format here to import it'
              )}
            </div>
            <FileInput
              multiple={false}
              accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              uploader={uploader}
            >
              <div className="qq-upload-button">
                <button className="btn btn-outline-secondary btn-sm">
                  {gt('Or browse your computer')}
                </button>
              </div>
            </FileInput>
          </>
        )}
      </FineUploaderArea>
    </StyledDropZoneDiv>
  );
};
